import React from 'react';
import moment from 'moment';
import { CERTIFICATE_STATUSES } from 'config/certificate';
import { CERTIFICATE_STATUSES_MESSAGES } from 'config/certificate';
import { history, store } from 'store/store';
import { hideNotification } from 'store/actions/notification';
import { ROUTE_CLIENT_ORDER_VIEW, ROUTE_CLIENT_ORGANIZATIONS_VIEW, ROUTE_CLIENT_USER_VIEW } from 'config/routes';
import { addParam } from 'api/helper';
import { Link } from "react-router-dom";
import { ORGANIZATION_STATUSES, USER_STATUSES } from '../../../../config/constants';
import { FormattedMessage } from 'react-intl';
import { LinkResource } from 'components/shared/LinkResource';
import { displayUsername } from 'helpers/displayUsername';
import { SendEmailRecover } from '../actionButtons/SendEmailRecover';

function CertificatesTableRow(props) {
  const { certificate, index } = props;

  if (! certificate) {
    return null;
  }

  const navigateToUser = (e) => {
    e.preventDefault();
    store.dispatch(hideNotification());
    const userPath = addParam(ROUTE_CLIENT_USER_VIEW, { ':userId': certificate.user.id });
    history.push({ pathname: userPath, search: '?tab=user' });
  };

  return (
    <tr>
      <td>{certificate.id}</td>
      <td className="w-10">
        {
          certificate.user?.id && certificate.user?.status === USER_STATUSES.ACTIVE ?
          <Link to="#" onClick={navigateToUser}>
            {displayUsername(certificate.user)}
          </Link> :
          <FormattedMessage id="components.pages.organizations.table.tableRow.user_deleted" />
        }
      </td>
      <td>
        {
          certificate.organization?.id && certificate.organization?.status === ORGANIZATION_STATUSES.CREATED ?
          <LinkResource
            displayText={certificate.organization.name}
            resourceLink={ROUTE_CLIENT_ORGANIZATIONS_VIEW}
            resourceParamId={{':organizationId': certificate.organization.id}}
          /> :
          <FormattedMessage id="components.pages.organizations.table.tableRow.organization_deleted" />
        }
      </td>
      <td>
        <Link
          to="#"
          onClick={(e) => {
            e.preventDefault();
            store.dispatch(hideNotification());
            history.push(
              addParam(ROUTE_CLIENT_ORDER_VIEW, { ':id': certificate.order_id }));
          }}
        >
          {certificate.order_number}
        </Link>
      </td>
      <td>
        {certificate.iut ? certificate.iut : '-'}
      </td>
      <td>
        {CERTIFICATE_STATUSES_MESSAGES[
          certificate.expires_at && moment(certificate.expires_at).isBefore(moment())
            ? CERTIFICATE_STATUSES[7]
            : CERTIFICATE_STATUSES[certificate.status]
        ]}
      </td>
      <td>{certificate.created_at ? moment(certificate.created_at).format('lll') : "-"}</td>
      <td>
        {certificate.expires_at ? moment(certificate.expires_at).format('lll') : "-"}
      </td>
      <td>
        <SendEmailRecover
          certificate={certificate}
          index={index}
          showIcon={true}
          actionCallback={() => props.actionCallback( true )}
        />
      </td>
    </tr>
  );
}

export { CertificatesTableRow };
